export default "__VITE_ASSET__CcZXNpXE__"